import {
    actionCreator,
    checkHttpStatus, 
    jsonApiHeader, 
    showErrorMessage, 
    showSuccessMessage, 
    showWarningMessage,
    consequencesActionTypes, 
    GET_MASTERDATABYNAME, 
    GET_CONSEQUENCES_LIST_API, 
    POST_CONSEQUENCES_API, 
    DELETE_CONSEQUENCES_API,
    GET_CONSEQUENCES_DETAIL_API
} from '../constants/ApiConstants';

import Alert from 'react-s-alert';
import { checkHttpStatusAuthCheck, createSearchUrlForCustomAPI } from '../../../../../../../actions/utilAction'; 
import { PatientRecordABCDataList } from '../../../../collectData/componnets/BehaviorData/actions/BehaviourDataActions';


export const getMasterData = (masterData) => {
    return (dispatch, getState) => {
        dispatch(actionCreator(consequencesActionTypes.get_masterData.REQUEST));
        fetch(`${GET_MASTERDATABYNAME}`, {
            method: 'post',
            body: JSON.stringify(masterData),
            headers: jsonApiHeader(getState().login.access_token, 'application/json'),
        })
            .then((res)=>checkHttpStatusAuthCheck(res,dispatch,getState))
            .then(function (response) {
                dispatch(actionCreator(consequencesActionTypes.get_masterData.SUCCESS, response));
            })
            .catch(function (error) {
                console.log('error getMasterData ..', error);
            });
    };
};

export const getConsequencesList = (searchObj) => {
    let query_params = createSearchUrlForCustomAPI(searchObj);
    return (dispatch, getState) => {
        dispatch(actionCreator(consequencesActionTypes.get_consequencesList.REQUEST));
        fetch(`${GET_CONSEQUENCES_LIST_API}${query_params}`, {
            method: 'get',
            headers: jsonApiHeader(getState().login.access_token, 'application/json'),
        })
            .then(checkHttpStatus)
            .then(function (response) {
                if (response.statusCode >= 200 && response.statusCode < 300 && response.statusCode !== 204) {
                    dispatch(actionCreator(consequencesActionTypes.get_consequencesList.SUCCESS, response));
                } else {
                    dispatch(actionCreator(consequencesActionTypes.get_consequencesList.SUCCESS, null));
                }
            }).catch(function (error) {
                console.log('error get_consequencesList', error);
            });
    };
};

export const getConsequencesListDetails = (reductionId) => {
    return (dispatch, getState) => {
        dispatch(actionCreator(consequencesActionTypes.get_consequencesDetail.REQUEST));
        fetch(`${GET_CONSEQUENCES_DETAIL_API}?reductionId=${reductionId}`, {
            method: 'get',
            headers: jsonApiHeader(getState().login.access_token, 'application/json'),
        })
            .then(checkHttpStatus)
            .then(function (response) {
                if (response.statusCode >= 200 && response.statusCode < 300 && response.statusCode !== 204) {
                    dispatch(actionCreator(consequencesActionTypes.get_consequencesDetail.SUCCESS, response));
                } else {
                    dispatch(actionCreator(consequencesActionTypes.get_consequencesDetail.SUCCESS, null));
                }
            }).catch(function (error) {
                console.log('error get_consequencesDetail', error);
            });
    };
};

export const saveConsequences = (formProps, patiendId) => {
    return (dispatch, getState) => {
        dispatch(actionCreator(consequencesActionTypes.save_consequences.REQUEST));
        fetch(`${POST_CONSEQUENCES_API}`, {
            method: 'POST',
            headers: jsonApiHeader(getState().login.access_token, 'application/json'),
            body: JSON.stringify(formProps),
        })
            .then(checkHttpStatus)
            .then(function (response) {
                if (response.statusCode >= 200 && response.statusCode < 300 && response.statusCode !== 204) {
                    showSuccessMessage(response.message);
                    dispatch(actionCreator(consequencesActionTypes.save_consequences.SUCCESS, response));
                    dispatch(PatientRecordABCDataList(patiendId))
                } else {
                    showErrorMessage(response.message);
                    dispatch(actionCreator(consequencesActionTypes.save_consequences.SUCCESS, null));
                }
            })
            .catch(function (error) {
                console.log('error save_consequences', error);
            });
    };
};

export const deleteConsequences = (reductionId) => {
    Alert.closeAll();
    return (dispatch, getState) => {
        dispatch(actionCreator(consequencesActionTypes.delete_consequences.REQUEST));
        fetch(`${DELETE_CONSEQUENCES_API}?reductionId=${reductionId}`, {
            method: 'PATCH',
            headers: jsonApiHeader(getState().login.access_token, 'application/json'),
        })
            .then(checkHttpStatus)
            .then((response) => {
                if (response.statusCode >= 200 && response.statusCode < 300 && response.statusCode !== 204) {
                    showSuccessMessage(response.message);
                    dispatch(actionCreator(consequencesActionTypes.delete_consequences.SUCCESS, response));
                } else if (response.statusCode === 401 || response.statusCode === 422) {
                    showWarningMessage(response.message);
                    dispatch(actionCreator(consequencesActionTypes.delete_consequences.SUCCESS, null));
                } else {
                    showErrorMessage(response.message);
                    dispatch(actionCreator(consequencesActionTypes.delete_consequences.SUCCESS, null));
                }
            }).catch(function (error) {
                console.log('error delete_consequences', error);
            });
    };
};



// WEBPACK FOOTER //
// ./src/modules/patients/components/DataCollection/BehaviorReductiom/Consequences/actions/consequencesActions.js